import { useSearchPanelView } from "../SearchPanel.context";

export function useSearchPanelHeader() {
  const {
    HeaderComponent,
    MoreDialogComponent,
    allSelected,
    data,
    hideSearchOnSelect,
    isLoading,
    onDeselectAll,
    onSearch,
    onSort,
    onTagDelete,
    onToggleSelectAll,
    openMore,
    search,
    selectable,
    selected,
    selectionDisabled,
    sort,
    sortOptions,
    sortWidth,
    tags,
  } = useSearchPanelView();

  const selectedCount = selected?.length || 0;
  const allSelectedDisabled =
    selectionDisabled || isLoading || data.length === 0;
  const shouldShowSearch = !hideSearchOnSelect || selected?.length === 0;

  return {
    HeaderComponent,
    MoreDialogComponent,
    allSelected,
    allSelectedDisabled,
    data,
    onDeselectAll,
    onSearch,
    onSort,
    onTagDelete,
    onToggleSelectAll,
    openMore,
    search,
    selectable,
    selectedCount,
    selectionDisabled,
    shouldShowSearch,
    sort,
    sortOptions,
    sortWidth,
    tags,
  };
}
